import React from 'react';
import './ReportList.css';
import { FaDownload } from 'react-icons/fa'; // Import download icon



// Data for the reports
// We pass this data in as a prop to make the component reusable
const ReportList = ({ title, description, reports }) => {
  return (
    <section className="report-list-section">
      <div className="report-list-container">
        <div className="section-header">
          <h2>{title}</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">{description}</p>

        <div className="reports-wrapper">
          {reports.map((report, index) => (
            <div key={index} className="report-item">
              <div className="report-item-image">
                <img src={report.image} alt={`${report.title} cover`} />
              </div>
              <div className="report-item-details">
                <span className="report-type">{report.type}</span>
                <span className="report-category">{report.category}</span>
                <h3>{report.title}</h3>
                <div className="report-index">
                  <h4>Index</h4>
                  <ul>
                    {report.index.map((item, i) => <li key={i}>{item}</li>)}
                  </ul>
                </div>
                <a href={report.sampleLink || '#'} className="download-sample-link">
                  <FaDownload /> Download Sample
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReportList;